import { render, staticRenderFns } from "./CreateRooms.vue?vue&type=template&id=1fac382a&scoped=true"
import script from "./CreateRooms.vue?vue&type=script&lang=js"
export * from "./CreateRooms.vue?vue&type=script&lang=js"
import style0 from "./CreateRooms.vue?vue&type=style&index=0&id=1fac382a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fac382a",
  null
  
)

export default component.exports